export default function HeroSection() {
  return (
    <section
      id="home"
      className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/32bd340daf1b12625ef9276fe51ccf42.jpg"
          alt="Hero background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full text-center px-6 flex flex-col items-center">
        <p className="text-white/50 text-xs tracking-[0.35em] uppercase mb-6 font-light">
          iOS Application Development
        </p>
        <h1 className="text-white text-5xl md:text-7xl font-bold tracking-tight leading-tight mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
          Built for the<br />
          <span className="italic font-normal">Modern World</span>
        </h1>
        <p className="text-white/70 text-base md:text-lg max-w-xl leading-relaxed font-light">
          CHIKO OOD engineers iOS products that redefine privacy, performance, and mobile security — so your digital life stays sharp and protected.
        </p>

        {/* Decorative scroll hint */}
        <div className="mt-16 flex flex-col items-center gap-2 opacity-50">
          <span className="text-white text-xs tracking-widest uppercase">Scroll</span>
          <div className="w-px h-10 bg-white/40" />
        </div>
      </div>

      {/* Bottom phone mockup area */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-sm pointer-events-none select-none opacity-30">
        <img
          src="https://readdy.ai/api/search-image?query=Sleek%20minimalist%20iPhone%20mockup%20silhouette%2C%20transparent%20glass%20effect%2C%20ultra-thin%20outline%20only%2C%20dark%20background%2C%20abstract%20glowing%20edge%2C%20no%20screen%20content%2C%20purely%20decorative%20device%20shape%2C%20modern%20elegant%20iOS%20aesthetic%2C%20centered%20composition&width=400&height=700&seq=chiko-phone-deco&orientation=portrait"
          alt=""
          className="w-full object-top object-contain"
        />
      </div>
    </section>
  );
}
